module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-element-profile-options"
  }, [_c('div', {
    staticClass: "btn-group w-100",
    attrs: {
      "role": "group",
      "aria-label": "Navigation"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-primary w-100",
    attrs: {
      "to": '/element/' + _vm.previousElementId,
      "tag": "button",
      "type": "button",
      "disabled": _vm.previousElementId === 0
    }
  }, [_vm._v(_vm._s(_vm.$t("sidebar.elementProfile.previous")))]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary w-100",
    attrs: {
      "to": '/element/' + _vm.nextElementId,
      "tag": "button",
      "type": "button",
      "disabled": _vm.nextElementId === _vm.numberOfElements + 1
    }
  }, [_vm._v(_vm._s(_vm.$t("sidebar.elementProfile.next")))])], 1), _vm._v(" "), _c('p', {
    staticClass: "text-muted mt-3"
  }, [_vm._v("Debug")]), _vm._v(" "), _c('mdc-switch', {
    model: {
      value: (_vm.debug),
      callback: function($$v) {
        _vm.debug = $$v
      },
      expression: "debug"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-458c3852"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/ElementProfileOptions.vue
// module id = 638
// module chunks = 1